import { CardioConstants } from './cardio.constants'
import { ICardioAction, ICardioNabc, ICardioPm, ICardioState } from './cardio.types'

export const initialCardioNabc: ICardioNabc = {
  cvTemp: '',
  cvTempDegrees: 'F',
  cvTempMethod: null,
  cvJvd: null,
  cvCapRefill: null,
  cvEdema: null,
  cvComments: '',
  cvArt: [],
  cvSwan: null,
}

export const initialCardioPm: ICardioPm = {
  type: null,
  rate: '',
  ma: '',
  pmMode: '',
}
export const initialCardioState: ICardioState = {
  prNabc: initialCardioNabc,
  prCvAssess: [],
  prPm: initialCardioPm,
}

export function cardioReducer(state: ICardioState = initialCardioState, action: ICardioAction): ICardioState {
  switch (action.type) {
    case CardioConstants.SET_CVTEMP:
      return {
        ...state,
        prNabc: {
          ...state.prNabc,
          cvTemp: action.cvTemp,
        },
      }
    case CardioConstants.SET_CVTEMPDEGREES:
      return {
        ...state,
        prNabc: {
          ...state.prNabc,
          cvTempDegrees: action.cvTempDegrees,
        },
      }
    case CardioConstants.SET_CVTEMPMETHOD:
      return {
        ...state,
        prNabc: {
          ...state.prNabc,
          cvTempMethod: action.cvTempMethod,
        },
      }
    case CardioConstants.SET_CVJVD:
      return {
        ...state,
        prNabc: {
          ...state.prNabc,
          cvJvd: action.cvJvd,
        },
      }
    case CardioConstants.SET_CVCAPREFILL:
      return {
        ...state,
        prNabc: {
          ...state.prNabc,
          cvCapRefill: action.cvCapRefill,
        },
      }
    case CardioConstants.SET_CVEDEMA:
      return {
        ...state,
        prNabc: {
          ...state.prNabc,
          cvEdema: action.cvEdema,
        },
      }
    case CardioConstants.SET_CVCOMMENTS:
      return {
        ...state,
        prNabc: {
          ...state.prNabc,
          cvComments: action.cvComments,
        },
      }
    case CardioConstants.SET_CVART:
      return {
        ...state,
        prNabc: {
          ...state.prNabc,
          cvArt: action.cvArt,
        },
      }
    case CardioConstants.SET_CVSWAN:
      return {
        ...state,
        prNabc: {
          ...state.prNabc,
          cvSwan: action.cvSwan,
        },
      }
    case CardioConstants.SET_PRCVASSESS:
      return { ...state, prCvAssess: action.prCvAssess }
    case CardioConstants.SET_TYPE:
      return {
        ...state,
        prPm: {
          ...state.prPm,
          type: action.pmType,
        },
      }
    case CardioConstants.SET_RATE:
      return {
        ...state,
        prPm: {
          ...state.prPm,
          rate: action.rate,
        },
      }
    case CardioConstants.SET_MA:
      return {
        ...state,
        prPm: {
          ...state.prPm,
          ma: action.ma,
        },
      }
    case CardioConstants.SET_PMMODE:
      return {
        ...state,
        prPm: {
          ...state.prPm,
          pmMode: action.pmMode,
        },
      }
    case CardioConstants.SAVE_INITIAL_ASSESSMENT_CARDIO_NABC:
      return {
        ...state,
        prNabc: { ...state.prNabc, ...action.prNabc },
      }
    case CardioConstants.SAVE_INITIAL_ASSESSMENT_CARDIO_PRPM:
      return {
        ...state,
        prPm: { ...state.prPm, ...action.prPm },
      }
    case CardioConstants.RESET_CARDIO_STATE:
      return {
        prNabc: {
          cvTemp: '',
          cvTempDegrees: 'C',
          cvTempMethod: null,
          cvJvd: null,
          cvCapRefill: null,
          cvEdema: null,
          cvComments: '',
          cvArt: [],
          cvSwan: null,
        },
        prCvAssess: [],
        prPm: {
          type: null,
          rate: '',
          ma: '',
          pmMode: '',
        },
      }
    case CardioConstants.RESET_PACEMAKER:
      return {
        ...state,
        prPm: { ...initialCardioPm },
      }
    case CardioConstants.RESET_INVASIVE_MONITORING:
      return {
        ...state,
        prNabc: {
          ...state.prNabc,
          cvArt: [],
          cvSwan: null,
        },
      }
    default:
      return state
  }
}
